<template>
  <div class="invitation">
    <!--    <van-nav-bar-->
    <!--      :title="$t('m.syicon4')"-->
    <!--      @click-left="onClickLeft"-->
    <!--      left-arrow-->
    <!--    ></van-nav-bar>-->
    <div class="dd-main">
      <div class="invite-flow">
        <div class="invite-card">
          <div class="yqm">
            <div style="font-size: 20px">{{ $t("m.yq_span0") }}：</div>
            <div style=" font-size:26px;font-weight:bold;color:#FF3738;">
              {{ data.invite }}
            </div>
            <button type="button" class="copy" @click="copyText(data.invite)">
              复制
            </button>
          </div>
          <div v-if="inviteSpreadUrl" class="yqm-spread">
            <div class="yqm-spread-label">推广链接</div>
            <div class="yqm-spread-inner">
              <div class="yqm-spread-url">{{ inviteSpreadUrl }}</div>
              <button
                type="button"
                class="spread-copy-btn"
                @click="copyText(inviteSpreadUrl, '复制成功')"
              >
                复制
              </button>
            </div>
          </div>
        </div>

        <div class="ercode">
          <img class="ercode-img" :src="qrCode" alt="" />
        </div>

        <div class="yqm1">
          <van-button
            :class="{ seled: type === 1 }"
            @click="tiaozhuan(1)"
            round
            type="primary"
          >
            安卓下载
          </van-button>
          <div class="dd-div">
            <van-button
              :class="{ seled: type === 2 }"
              @click="tiaozhuan(2)"
              round
              type="primary"
            >
              苹果下载一
            </van-button>
            <van-button
              :class="{ seled: type === 3 }"
              @click="tiaozhuan(3)"
              round
              type="primary"
            >
              苹果下载二
            </van-button>
          </div>
          <span class="yqm1-tip">使用浏览器扫描二维码下载app</span>
        </div>
      </div>

      <div class="jjjs">
        <p class="invite-kf-tip">
          申请成为代理及了解更多推广政策请联系客服
        </p>
        <van-button
          type="primary"
          round
          class="invite-kf-btn"
          @click="openCustomerService"
        >
          联系客服
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getHyDataInfo } from "@api/user";
import $store from "../../store";
import { isKfHttpOnHttpsPage } from "@utils/index";

export default {
  data() {
    return {
      data: {},
      qrCode: "",
      type: 1
    };
  },
  created() {
    this.getData();
  },
  computed: {
    inviteSpreadUrl() {
      const code = this.data && this.data.invite;
      if (!code) return "";
      const base = `${window.location.origin}${window.location.pathname}`;
      return `${base}#/register?invite=${encodeURIComponent(code)}`;
    }
  },
  methods: {
    /** 与底部 Tab「客服」一致 */
    openCustomerService() {
      const kf = String($store.state.app.kf || "").trim();
      if (kf && isKfHttpOnHttpsPage(kf)) {
        window.location.href = kf;
        return;
      }
      this.$router.push({ path: "/customerService" });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    tiaozhuan(index) {
      this.data.qrCode = "";
      this.type = index;
      switch (index) {
        case 1:
          this.qrCode = this.data.app_android_url;
          break;
        case 2:
          this.qrCode = this.data.app_ios_url1;
          break;
        case 3:
          this.qrCode = this.data.app_ios_url2;
          break;
      }
    },
    getData() {
      getHyDataInfo().then(res => {
        this.data = res.data.data;
        console.log("-> this.data", this.data);
        this.qrCode = this.data.app_android_url;
      });
    },
    //复制文本
    copyText(text, successMsg) {
      if (text == null || text === "") return;
      var element = this.createElement(String(text));
      element.select();
      element.setSelectionRange(0, element.value.length);
      document.execCommand("copy");
      element.remove();
      this.$toast.success(
        successMsg != null && successMsg !== ""
          ? successMsg
          : "您成功复制了" + text
      );
    },
    //创建临时的输入框元素
    createElement(text) {
      var isRTL = document.documentElement.getAttribute("dir") === "rtl";
      var element = document.createElement("textarea");
      // 防止在ios中产生缩放效果
      element.style.fontSize = "12pt";
      // 重置盒模型
      element.style.border = "0";
      element.style.padding = "0";
      element.style.margin = "0";
      // 将元素移到屏幕外
      element.style.position = "absolute";
      element.style[isRTL ? "right" : "left"] = "-9999px";
      // 移动元素到页面底部
      let yPosition = window.pageYOffset || document.documentElement.scrollTop;
      element.style.top = `${yPosition}px`;
      //设置元素只读
      element.setAttribute("readonly", "");
      element.value = text;
      document.body.appendChild(element);
      return element;
    }
  }
};
</script>

<style lang="less">
.dd-main {
  width: 100%;
  min-height: 100vh;
  background: url("../../assets/images/img/img/yqpp.png") no-repeat;
  position: relative;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: calc(10vh + env(safe-area-inset-top, 0px)) 14px 12px;
}
.invitation {
  width: 100%;
  min-height: 100vh;
  background-size: 100% 100%;
  position: relative;
  z-index: 999;
}

.jjjs {
  position: relative;
  margin-top: auto;
  padding-top: 20px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-weight: 700;
  flex-shrink: 0;
}

.invite-kf-tip {
  margin: 0 0 14px;
  padding: 0 12px;
  font-size: 14px;
  line-height: 1.55;
  color: #333;
  text-align: center;
  font-weight: 500;
}

.invite-kf-btn {
  min-width: 200px;
  height: 44px;
  font-size: 16px;
  font-weight: 600;
}

.seled {
  background-color: #dadada !important;
}

.invite-flow {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  box-sizing: border-box;
}

.invite-card {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 16px 16px 14px;
  box-sizing: border-box;
  background: linear-gradient(165deg, #fffdf8 0%, #fff 50%, #fff9f0 100%);
  border: 1px solid rgba(205, 165, 105, 0.45);
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(80, 60, 20, 0.1);
  margin-top: 65px;
}

.yqm {
  color: #666;
  width: 100%;
  text-align: center;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  .copy {
    border-radius: 20px;
    margin-left: 5px;
    padding: 2px 8px;
    color: #ffc107;
    font-size: 12px;
    vertical-align: middle;
    border: 2px solid #ffc107;
    background: transparent;
    flex-shrink: 0;
  }
}

.yqm-spread {
  margin-top: 14px;
  padding-top: 14px;
  width: 100%;
  box-sizing: border-box;
  border-top: 1px dashed rgba(205, 165, 105, 0.45);
}

.yqm-spread-label {
  font-size: 15px;
  font-weight: 600;
  color: #7a5e28;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
}

.yqm-spread-label::before {
  content: "";
  width: 3px;
  height: 15px;
  background: #cda569;
  border-radius: 2px;
  margin-right: 8px;
  flex-shrink: 0;
}

.yqm-spread-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.yqm-spread-url {
  flex: 1;
  min-width: 0;
  word-break: break-all;
  line-height: 1.45;
  color: #444;
  font-size: 12px;
}

.spread-copy-btn {
  flex-shrink: 0;
  border: none;
  border-radius: 999px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(180deg, #d4b27a 0%, #cda569 45%, #b8924f 100%);
  box-shadow: 0 2px 8px rgba(205, 165, 105, 0.45);
}

.spread-copy-btn:active {
  opacity: 0.92;
}

.yqm1 {
  position: relative;
  top: auto;
  font-size: 16px;
  width: 100%;
  max-width: 400px;
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #ffffff;
  flex-shrink: 0;

  .dd-div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    button {
      width: 48%;
    }
  }

  button {
    width: 100%;
    margin-bottom: 10px;
  }
}

.yqm1 button {
  font-size: 16px;
  font-weight: bold;
  background: #ffcc49;
  height: 45px;
  color: #ffffff;
  border: 0px solid;
}

.yqm1-tip {
  margin-top: 8px;
  font-size: 13px;
  text-align: center;
  line-height: 1.4;
  opacity: 0.95;
  color:#b8924f;
}

.ercode {
  position: relative;
  width: 100%;
  margin-top: 0px;
  padding: 12px 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  z-index: 0;
}

.ercode-img {
  width: 120px;
  height: 120px;
  max-width: min(120px, 36vw);
  max-height: min(120px, 36vw);
  object-fit: contain;
  display: block;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}
</style>
